// extracted by mini-css-extract-plugin
export default {"container":"AsAttendee_container__9fPR0","row":"AsAttendee_row__zk41N","column":"AsAttendee_column__4e7E+","switch":"AsAttendee_switch__Ax3Vs"};